import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Lang, ThemeProvider, Toaster, ToasterComponent, ToasterProvider, configure } from '@gravity-ui/uikit';
import './styles/app.css';
import { createSessionStore } from './lib/session/store.js';
import { App } from './app/app.js';

/**
 * Кабинет менеджера. Сессия — токен в памяти и refresh в cookie; service
 * worker — только в собранной версии. Интерфейс — Gravity UI, как у
 * админки: золото Odonix, Roboto, подписи компонентов по-русски.
 */

configure({ lang: Lang.Ru });

const container = document.getElementById('root');
if (container === null) throw new Error('Не найден корневой элемент');

const session = createSessionStore({ baseUrl: apiBaseUrl() });
const toaster = new Toaster();

createRoot(container).render(
  <StrictMode>
    <ThemeProvider theme="light" lang={Lang.Ru}>
      <ToasterProvider toaster={toaster}>
        <App session={session} />
        <ToasterComponent />
      </ToasterProvider>
    </ThemeProvider>
  </StrictMode>,
);

registerAppServiceWorker();

function registerAppServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const register = (): void => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' });
  };
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}

function apiBaseUrl(): string {
  const configured: unknown = import.meta.env.VITE_API_BASE_URL;
  return typeof configured === 'string' && configured !== '' ? configured : window.location.origin;
}
